
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic01On as ObiLogic01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-01-on.js';
 
 
 

 
 export const ObiLogic01On = createComponent({
   react: React,
   tagName: 'obi-logic-01-on',
   elementClass: ObiLogic01OnElement,
   events: {
     
   }
  });
 
 